import { render, staticRenderFns } from "./DownloadLog.vue?vue&type=template&id=1bfda1f1&"
import script from "./DownloadLog.vue?vue&type=script&lang=js&"
export * from "./DownloadLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports